import { render } from "./business-license.vue?vue&type=template&id=59cb49a0&scoped=true"
import script from "./business-license.vue?vue&type=script&lang=js"
export * from "./business-license.vue?vue&type=script&lang=js"

import "./business-license.vue?vue&type=style&index=0&id=59cb49a0&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59cb49a0"]])

export default __exports__